"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _searchModule = require("../shared-components/search-module");
var _customInputHoc = _interopRequireDefault(require("../elements-inputs/custom-input-hoc"));
var _form = require("../shared-components/forms/form");
var _activityDropdownHoc = _interopRequireDefault(require("../elements-search-module/activity-dropdown-hoc"));
var _locationDropdownHoc = _interopRequireDefault(require("../elements-search-module/location-dropdown-hoc"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var ActivityDropdownCustom = (0, _customInputHoc.default)((0, _activityDropdownHoc.default)(_searchModule.ActivityDropdown));
var LocationDropdownCustom = (0, _customInputHoc.default)((0, _locationDropdownHoc.default)(_searchModule.LocationDropdown));
var SearchFormNav = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchFormNav, _React$Component);
  function SearchFormNav(props) {
    var _this;
    _classCallCheck(this, SearchFormNav);
    _this = _callSuper(this, SearchFormNav, [props]);
    _this.inputRefs = {};
    return _this;
  }
  _createClass(SearchFormNav, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var formInputs = [{
        custom: /*#__PURE__*/_react.default.createElement("div", {
          className: "col-xs-offset-1 col-xs-10 margin-md-bottom no-gutter"
        }, /*#__PURE__*/_react.default.createElement(ActivityDropdownCustom, {
          ref: function ref(_ref) {
            _this2.inputRefs.activity = _ref;
            if ('function' === typeof _this2.props.dropdownRefs) _this2.props.dropdownRefs(_ref, 'activityInputRef');
          },
          activityRef: function activityRef(ref) {
            if ('function' === typeof _this2.props.dropdownRefs) _this2.props.dropdownRefs(ref, 'activityRef');
          } // this ref will allow us to toggle the dropdown
          ,
          inputFieldName: "activity",
          inputClassName: "normalize-inputs",
          selectedFilters: {
            useTypeObj: this.props.dropdown,
            useTypeId: this.props.dropdownId
          },
          optional: true
        }))
      }, {
        custom: /*#__PURE__*/_react.default.createElement("div", {
          className: "col-xs-offset-1 col-xs-10 margin-md-bottom no-gutter"
        }, /*#__PURE__*/_react.default.createElement(LocationDropdownCustom, {
          ref: function ref(_ref2) {
            _this2.inputRefs.location = _ref2;
          },
          toggleSearchDisable: this.toggleSearchDisable,
          locationRef: function locationRef(ref) {
            if ('function' === typeof _this2.props.dropdownRefs) _this2.props.dropdownRefs(ref, 'locationRef');
          } // this ref will allow us to toggle the dropdown
          ,
          inputFieldName: "location",
          inputClassName: "normalize-inputs",
          optional: true
        }))
      }];
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "search-form-nav"
      }, /*#__PURE__*/_react.default.createElement(_form.FormBuilder, {
        errorText: '',
        inputRefs: this.inputRefs,
        formname: "nav-search-module",
        formStyle: "standard",
        formInputs: formInputs,
        formClassString: "col-lg-12 no-gutter",
        submitAction: this.props.submitAction,
        submitCallback: this.props.submitCallback,
        buttonText: this.props.intl.formatMessage({
          id: 'search_form.search_form_nav.fees_overview',
          defaultMessage: 'Search'
        }),
        btnColSize: "col-xs-offset-1 col-xs-10 no-gutter",
        buttonClass: "btn btn-lg btn-block btn-primary form force-button",
        optionalButtonAttributes: {
          'data-testing-id': 'nav-search'
        }
      }));
    }
  }]);
  return SearchFormNav;
}(_react.default.Component);
SearchFormNav.propTypes = {
  dropdown: _propTypes.default.string,
  dropdownId: _propTypes.default.string,
  submitAction: _propTypes.default.func,
  submitCallback: _propTypes.default.func,
  dropdownRefs: _propTypes.default.func
};
exports.SearchFormNav = (0, _reactIntl.injectIntl)(SearchFormNav);